import { combineReducers } from 'redux';
import Ssg from '../../reducers/ssg/reducer';

export default combineReducers({
  Ssg
});
